import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Skeleton,
  Typography,
} from "@mui/material";
import { colors } from "colors";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "context/react-lib/firebase-auth/AuthProvider";
import { editorActions } from "store/editor";
import DocumentMenu from "./DocumentMenu";
import CodeIcon from "@mui/icons-material/Code";
import { MARKDOWN_DOC_TYPE } from "schemas/documents";
import TextSnippetIcon from '@mui/icons-material/TextSnippet';

export default function DocumentList({handelSave}) {

  const documentsState = useSelector((state) => state.documents);
  const activeDocument = useSelector((state) => state.editor?.activeDocument);

  const auth = useAuth();

  const activeDocumentId = useSelector(
    (state) => state.editor.activeDocument?.id
  );
  const dispatch = useDispatch();

  if (documentsState.error) {
    console.log(documentsState.error);
    return null;
  }

  
  const changeActiveDocument = (newDocument) => {
    handelSave();
    dispatch(editorActions.setActiveDocument(newDocument));

  }

  const renderDocuments = () => {
    const documents = documentsState.documents;
    if (!documents) return null;
    if (documents.length === 0) {
      return (
        <ListItem>
          <ListItemText
            sx={{
              color: colors.white,
            }}
          >
            No documents.
          </ListItemText>
        </ListItem>
      );
    }
    return documents.map((document, index) => {
      return (
        <ListItem
          key={document.id}
          secondaryAction={
            <DocumentMenu
              previous={index === 0 ? null : documents[index - 1]}
              next={index + 1 >= documents.length ? null : documents[index + 1]}
              document={document}
              color="white"
            />
          }
          sx={{
            borderRadius: "4px",
            backgroundColor:
              document.id === activeDocumentId ? colors.drakGray : colors.black,
          }}
        >
          <ListItemIcon>
            {document.type === MARKDOWN_DOC_TYPE ? (
              <TextSnippetIcon />
            ) : (
              <CodeIcon />
            )}
          </ListItemIcon>
          <ListItemButton
            onClick={() => changeActiveDocument(document)}
          >
            <ListItemText
              sx={{
                color: colors.white,
              }}
              primary={<Typography>{document.name}</Typography>}
              secondary={
                <Typography variant="caption">
                  {new Date(document.createdAt).toLocaleString()}
                </Typography>
              }
            />
          </ListItemButton>
        </ListItem>
      );
    });
  };

  return (
    <List dense disablePadding>
      {documentsState.loading ? (
        <>
          {Array.from(Array(3)).map((x, index) => (
            <ListItem key={`document-skeleton-${index}`}>
              <ListItemText
                primary={
                  <Skeleton variant="text" sx={{ bgcolor: colors.drakGray }} />
                }
                secondary={
                  <Skeleton variant="text" sx={{ bgcolor: colors.drakGray }} />
                }
              />
            </ListItem>
          ))}
        </>
      ) : (
        renderDocuments()
      )}
    </List>
  );
}
